var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function generateUrlFromSource(key, extension, cdnHost) {
  return "".concat(cdnHost, "/").concat(key.replace(/_/g, "/"), ".").concat(extension);
}
__name(generateUrlFromSource, "generateUrlFromSource");
export {
  generateUrlFromSource
};
